import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingAiImageEditorConfig } from '@/data/landingConfig/landingAiImageEditorConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_AiImageEditor } from './schemaObject';

interface Props {}
const AiImageEditor: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_AiImageEditor} />
			<LandingTemplate
				data={landingAiImageEditorConfig}
				funnelLinkService={GenerateLandingLinkService.funnelAiEditor()}
			/>
		</>
	);
};

export default AiImageEditor;
